import { LoadableAfterPaint } from '@confluence/loadable';

export const CustomFooterLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CustomHeaderFooter" */ './CustomHeaderFooter.tsx'))
			.CustomHeaderFooter,
});
